<template>
<div class="row">
    <!-- BEGIN Phone country code -->
    <section class="col col-3">
        <label class="label">{{ $label('common.phone_number') }}</label>
        <label class="input">
            <input v-model="phoneNumber.prefix"
                v-on:keyup.enter="requestModelChange"
                :class="{ 'text-input-error': hasError('prefix') }"
                :disabled="updating"
                type="text"
                placeholder="+XX"
            />
        </label>

        <p v-if="hasError('prefix')" class="text-danger">{{ getError('prefix') }}</p>
    </section>
    <!-- END Phone country code -->

    <!-- BEGIN Phone number -->
    <section class="col col-9">
        <label class="label">&nbsp;</label>

        <label class="input">
            <i class="icon-append icon-phone"></i>
            <input v-model="phoneNumber.number"
                v-on:keyup.enter="requestModelChange"
                :class="{ 'text-input-error': hasError('number') }"
                :disabled="updating"
                type="text"
                placeholder="XXXXXXXX"
            />
        </label>

        <p v-if="hasError('number')" class="text-danger">{{ getError('number') }}</p>
    </section>
    <!-- END Phone number -->
</div>
</template>

<script>
import Api from '@/api';
import FormErrorsMixin from '@/mixins/FormErrors.js';
import ModelActionsMixin from '@/mixins/ModelActions.js';

export default {
    props: ['resourceType', 'resourceId', 'updating'],

    mixins: [FormErrorsMixin, ModelActionsMixin],

    data() {
        return {
            validatedInputs: ['prefix', 'number'],
            parentView: 'operatorBaseDetails',
            modelData: 'phoneNumber',
            phoneNumber: {
                id: null,
                prefix: null,
                number: null,
            },
        }
    },

    mounted() {
        this.initializePhoneNumber();
    },

    methods: {
        initializePhoneNumber() {
            if (!this.resourceId) {
                return;
            }
            this.getPhoneNumber();
        },

        getPhoneNumber(successCallback) {
            let endpoint = 'partners/demo_partner/' + this.resourceType + '/' + this.resourceId + '/phone-number';
            Api().get(endpoint)
                .then((response) => {
                    this.phoneNumber = response.data.data;
                    if (typeof successCallback == 'function') {
                        successCallback();
                    } else {
                        this.emitModelLoadedEvent();
                    }
                })
                .catch((error) => {
                    this.resetModel();
                    this.emitModelLoadedEvent(false);
                });
        },

        storeModel() {
            this.resetErrors();
            let endpoint = 'partners/demo_partner/' + this.resourceType + '/' + this.resourceId + '/phone-number';

            Api().post(endpoint, this.phoneNumber)
                .then((response) => {
                    this.getPhoneNumber(() => {
                        this.emitModelUpdatedEvent();
                    })
                })
                .catch((error) => {
                    this.emitModelUpdatedEvent(false);
                    this.storeErrors(error.response.data.errors);
                });
        },

        updateModel() {
            this.resetErrors();
            let endpoint = 'partners/demo_partner/phone-numbers/' + this.phoneNumber.id;

            Api().put(endpoint, this.phoneNumber)
                .then((response) => {
                    this.emitModelUpdatedEvent();
                })
                .catch((error) => {
                    this.emitModelUpdatedEvent(false);
                    this.storeErrors(error.response.data.errors);
                });
        },

        deleteModel() {
            this.resetErrors();
            let endpoint = this.$partnerEndpoint('phone-numbers/' + this.phoneNumber.id);

            Api().delete(endpoint)
                .then((response) => {
                    this.phoneNumber.id = null;
                    this.emitModelUpdatedEvent();
                })
                .catch((error) => {
                    this.emitModelUpdatedEvent(false);
                });
        },
    },

    watch: {
        resourceId(resourceId) {
            this.initializePhoneNumber();
        },
    }
}
</script>
